const formatDate = (value?: string): string =>
  value ? new Date(value).toLocaleDateString() : "";

export const formatDateTime = (value?: string): string =>
  value ? new Date(value).toLocaleString() : "";

export default formatDate;
